import t from 'react-translate';

import { css } from '@emotion/react';
import { gray2, gray7 } from 'styles/global_defaults/colors';

import NvIcon from 'shared/components/nv-icon';

const styles = css`
  height: 200px;
  .error-container {
    background-color: ${gray7};
    i {
      color: ${gray2};
    }
  }
`;

const AvailabilityCalendarError = () => (
  <div
    css={styles}
    className='px-3 py-2 d-flex align-items-center justify-content-center'
  >
    <div className='d-flex flex-column align-items-center h-100 error-container justify-content-center px-2'>
      <NvIcon icon='warning' size='smallest' className='pb-1' />
      <div className='text-regular semi-bold'>
        {t.MENTORING_PROGRAMS.PARTICIPANT_HOME.PLAN_SESSION_FLYOUT.EDIT_MODE.SCHEDULING_WITH_AVAILABILITY.ERROR.TITLE()}
      </div>
      <div className='text-center text-regular'>
        {t.MENTORING_PROGRAMS.PARTICIPANT_HOME.PLAN_SESSION_FLYOUT.EDIT_MODE.SCHEDULING_WITH_AVAILABILITY.ERROR.DESCRIPTION()}
      </div>
    </div>
  </div>
);

export default AvailabilityCalendarError;
